import VWMeasurements from '../vw-measurements';

export default class LoadFactor {
  data = null;

  vw = null;

  constructor (data, company) {
    this.data = data;

    this.vw = new VWMeasurements(data, company);
  }

  get weight () {
    return this.vw.weight;
  }

  get volume () {
    return this.vw.volume;
  }

  get shipments () {
    return this.data.shipments;
  }

  get pieces () {
    return this.data.pieces;
  }

  get weightPercent () {
    return this.data.weightPercent;
  }

  get volumePercent () {
    return this.data.volumePercent;
  }

  get maxPercent () {
    return Math.max(this.volumePercent, this.weightPercent);
  }
};
